import React from 'react'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import DecoupledEditorBasic from '@minutes/editor'

type EditorProps = {
    placeholder?: string
    data?: string
    runtimeConfig?: Record<string, any>
    onAutosave?: (editor: any) => void
    onReady?: (editor: any) => void
    onChange?: (event: any, editor: any) => void
    onBlur?: (event: any, editor: any) => void
    onFocus?: (editor: any) => void
    handleError?: (error: any) => void
    getAiSupport?: (payload: string | Record<string, unknown>) => Promise<unknown>
}

function attachStickyToolbarOnFocus(editorInstance: any) {
    const syncToolbarPosition = () => {
        const toolbarElement = editorInstance.ui.view.toolbar.element
        if (!toolbarElement) return
        toolbarElement.style.position = editorInstance.ui.focusTracker.isFocused ? 'sticky' : 'static'
    }

    editorInstance.ui.focusTracker.on('change:isFocused', syncToolbarPosition)
    editorInstance.on('destroy', () => {
        editorInstance.ui.focusTracker.off('change:isFocused', syncToolbarPosition)
    })
}

export function Editor({
    data = '',
    placeholder,
    onAutosave,
    runtimeConfig = {},
    getAiSupport,
    ...rest
}: EditorProps) {
    function onInit(editorInstance: any) {
        rest.onReady && rest.onReady(editorInstance)

        if (getAiSupport) {
            editorInstance.getAiSupport = getAiSupport
        }

        attachStickyToolbarOnFocus(editorInstance)
    }

    /** ckeditor5-react calls onFocus(event, editor) — never use React state here (it lags behind onReady). */
    function onFocus(_event: any, focusEditor: any) {
        rest.onFocus && rest.onFocus(focusEditor)
    }

    const config = {
        placeholder,
        autosave: { save: onAutosave, waitingTime: 200 },
        ...runtimeConfig
    }
    if (getAiSupport) {
        (config as any).isAISupported = true
    }
    return (
        <CKEditor
            editor={DecoupledEditorBasic.DecoupledEditorBasic}
            data={data || ''}
            config={config}
            onReady={onInit}
            onFocus={onFocus}
            onChange={rest.onChange}
            onBlur={rest.onBlur}
        />
    )
}

export function Realtime({
    data = '',
    placeholder,
    onAutosave,
    runtimeConfig = {},
    getAiSupport,
    ...rest
}: EditorProps) {
    function onInit(editorInstance: any) {
        rest.onReady && rest.onReady(editorInstance)

        if (getAiSupport) {
            editorInstance.getAiSupport = getAiSupport
        }

        attachStickyToolbarOnFocus(editorInstance)
    }

    function onFocus(_event: any, focusEditor: any) {
        rest.onFocus && rest.onFocus(focusEditor)
    }

    const config = {
        placeholder,
        autosave: { save: onAutosave, waitingTime: 200 },
        ...runtimeConfig
    }
    if (getAiSupport) {
        (config as any).isAISupported = true
    }
    return (
        <CKEditor
            editor={DecoupledEditorBasic.DecoupledEditorRealtime}
            data={data || ''}
            config={config}
            onReady={onInit}
            onFocus={onFocus}
            onChange={rest.onChange}
            onBlur={rest.onBlur}
            onError={rest.handleError}
        />
    )
}
